import { useState } from 'react';
import type { AbgleichZeile } from '../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';
import type { AbgleichAuswahl } from './AbgleichTabelle';

export function useAbgleichAuswahl(zeilen: AbgleichZeile[]): AbgleichAuswahl {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  function onToggleRow(id: string, checked: boolean) {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (checked) {
        next.add(id);
      } else {
        next.delete(id);
      }
      return next;
    });
  }

  function onToggleAll(checked: boolean) {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      zeilen.forEach((z) => (checked ? next.add(z.id) : next.delete(z.id)));
      return next;
    });
  }

  return { selectedIds, onToggleAll, onToggleRow };
}
